import APIService from './APIService';

class NotificationService {
  /**
   * Get notifications with pagination
   * @param {number} page - Page number
   * @param {number} limit - Items per page
   * @returns {Promise<{notifications: Array, meta: Object, unreadNotifications: number}>}
   */
  static async getNotifications(page = 1, limit = 20) {
    try {
      const response = await APIService.get(`/notifications?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  }

  /**
   * Mark a notification as read
   * @param {string} notificationId - Notification ID
   * @returns {Promise<Object>}
   */
  static async markAsRead(notificationId) {
    try {
      const response = await APIService.patch(`/notifications/${notificationId}/read`);
      return response.data;
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  }

  /**
   * Mark all notifications as read
   * @param {string} fromNotificationId - Mark all from this notification ID
   * @returns {Promise<Object>}
   */
  static async markAllAsRead(fromNotificationId) {
    try {
      const response = await APIService.patch('/notifications/read-all', {
        fromNotificationId,
      });
      return response.data;
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      throw error;
    }
  }

  /**
   * Delete a notification
   * @param {string} notificationId - Notification ID
   * @returns {Promise<Object>}
   */
  static async deleteNotification(notificationId) {
    try {
      const response = await APIService.delete(`/notifications/${notificationId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting notification:', error);
      throw error;
    }
  }

  /**
   * Get unread notification count
   * @returns {Promise<number>}
   */
  static async getUnreadCount() {
    try {
      const response = await APIService.get('/notifications/unread/count');
      return response.data.count || 0;
    } catch (error) {
      console.error('Error fetching unread count:', error);
      throw error;
    }
  }
}

export default NotificationService;
